// @alamo/ui · WizardFooterSlotContext
//
// Bridge between WizardShell and WizardFooterPin: the shell exposes a slot
// element rendered as the LAST child of its column (outside the padded
// content container), and WizardFooterPin teleports itself into that slot
// via portal. Steps keep rendering <WizardFooterPin> inline (they own the
// callbacks/labels), but the bar lands full-bleed at the real bottom of the
// shell column — so `sticky bottom-0` always reaches the viewport bottom and
// the bar never inherits the container's horizontal/vertical padding.
//
// Value `null` = no shell slot available → WizardFooterPin renders in place
// (standalone usage keeps working unchanged).

import { createContext } from 'react';

export const WizardFooterSlotContext = createContext<HTMLDivElement | null>(null);
